module.exports = __webpack_public_path__ + "static/img/9.73612dff.png";